import React from 'react';

const PATHS = {
  roundedRect: "M796.78,1080H283.22C126.8,1080,0,953.2,0,796.78V283.22C0,126.8,126.8,0,283.22,0h513.57C953.2,0,1080,126.8,1080,283.22v513.57C1080,953.2,953.2,1080,796.78,1080z",
  tForm: "M679.1,665.9v14.5c0,62.47-30.17,83.26-71.75,83.26c-42.64,0-72.81-21.85-72.81-83.26V494.26V367.3V185.31h-140.5V367.3H260.49v126.97h133.54v186.15c0,144.66,86.35,214.29,213.32,214.29c125.81,0,212.16-69.62,212.16-214.29v-14.5H679.1z",
  arrowL: "M735.97,433.03c1.11,0,1.7,0,2.3,0c17.21,0,34.41,0,51.62,0c3.15,0,4.82,1.19,4.86,3.47c0.04,2.34-1.68,3.6-4.91,3.6c-17.21,0-34.41,0-51.62,0c-0.6,0-1.19,0-2.09,0c0.49,0.56,0.78,0.93,1.11,1.26c2.31,2.31,4.66,4.58,6.92,6.93c1.39,1.44,1.3,3.58-0.05,4.93c-1.33,1.34-3.41,1.54-4.79,0.18c-4.87-4.76-9.67-9.58-14.44-14.42c-1.1-1.11-0.98-3.3,0.26-4.55c4.73-4.81,9.5-9.59,14.33-14.31c1.46-1.43,3.56-1.24,4.91,0.17c1.39,1.45,1.39,3.55-0.14,5.04c-1.9,1.86-3.88,3.62-5.83,5.43C737.72,431.4,737.04,432.04,735.97,433.03z",
  arrowR: "M782.74,404.66c-4.6,0-8.74,0-12.89,0c-13.56,0-27.11,0-40.67,0c-0.61,0-1.22,0.02-1.82-0.03c-1.82-0.15-3.2-1.58-3.28-3.36c-0.08-1.81,1.31-3.45,3.17-3.65c0.82-0.09,1.66-0.04,2.49-0.04c16.93,0,33.86,0,50.79,0c0.61,0,1.21,0,2.09,0c-0.4-0.47-0.63-0.8-0.92-1.07c-2.24-2.14-4.51-4.25-6.74-6.41c-1.68-1.63-1.76-3.81-0.28-5.29c1.46-1.46,3.55-1.45,5.17,0.15c4.6,4.55,9.18,9.13,13.74,13.73c1.63,1.64,1.61,3.63-0.03,5.28c-4.52,4.56-9.06,9.1-13.62,13.61c-1.67,1.65-3.85,1.68-5.29,0.17c-1.38-1.45-1.29-3.6,0.28-5.19c2.13-2.17,4.31-4.3,6.46-6.45C781.77,405.74,782.11,405.34,782.74,404.66z",
};

const CSS = `
  @keyframes t09n-breathe {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.55; }
  }
  @keyframes t09n-cpulse {
    0%, 100% { transform: scale(1); }
    50%       { transform: scale(1.09); }
  }
  @keyframes t09n-atick {
    0%, 55%, 100% { opacity: 1; }
    28%            { opacity: 0.15; }
  }
  .t09n-lb { animation: t09n-breathe 2s cubic-bezier(.42,0,.58,1) infinite; }
  .t09n-cp {
    animation: t09n-cpulse 2s cubic-bezier(.42,0,.58,1) infinite;
    transform-box: fill-box;
    transform-origin: center;
  }
  .t09n-at { animation: t09n-atick 2s cubic-bezier(.42,0,.58,1) infinite; }
`;

export function T09nLoader({ size = 48, variant = 'light', label = 'Processing' }) {
  const dark   = variant === 'dark';
  const bg     = dark ? '#ffffff' : '#000000';
  const shape  = dark ? '#000000' : '#ffffff';
  const circle = dark ? '#ffffff' : '#000000';
  const arrows = dark ? '#000000' : '#ffffff';
  const tGlyph = dark ? '#ffffff' : '#000000';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1080 1080"
      role="img"
      aria-label={label}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <style>{CSS}</style>
      <g className="t09n-lb">
        <rect width="1080" height="1080" fill={bg} />
        <path fill={shape} d={PATHS.roundedRect} />
        <g className="t09n-cp">
          <circle cx="759.44" cy="419.03" r="65.46" fill={circle} />
          <g className="t09n-at">
            <path fill={arrows} d={PATHS.arrowL} />
            <path fill={arrows} d={PATHS.arrowR} />
          </g>
        </g>
        <path fill={tGlyph} d={PATHS.tForm} />
      </g>
    </svg>
  );
}

export function T09nLoaderOverlay({ show, message = 'Processing…', variant = 'light' }) {
  if (!show) return null;
  const dark = variant === 'dark';
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        backgroundColor: dark
          ? 'rgba(17,24,39,0.75)'
          : 'rgba(255,255,255,0.80)',
      }}
      aria-live="polite"
      aria-label={message}
    >
      <T09nLoader size={72} variant={variant} label={message} />
      <span style={{
        fontSize: '12px',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        fontWeight: 500,
        color: dark ? '#9ca3af' : '#374151',
        fontFamily: 'inherit',
      }}>
        {message}
      </span>
    </div>
  );
}

export default T09nLoader;
